import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Attach the auth token at request time, read straight from localStorage.
//
// Previously the Authorization header was only set from AuthContext's effect
// (axiosInstance.defaults.headers...). On a fresh page load React runs the
// MeContext child effect - which fires getMe() - before the AuthContext parent
// effect that sets the header, so the first /api/Me request could go out
// unauthenticated (401). MeContext then stored me = null and the app rendered
// "No clinic yet"; a manual "Check again" worked because by then the header was
// set. Reading the token per request removes that ordering race entirely.
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// MembershipEnforcementMiddleware answers 403 with a membershipStatus when the
// user's access has changed under them (deactivated, declined). Ask MeContext to
// re-read /api/Me so the gate screen replaces a page full of failed requests.
export const MEMBERSHIP_CHANGED_EVENT = 'vqura:membership-changed';

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 403 && error.response.data?.membershipStatus) {
      window.dispatchEvent(new Event(MEMBERSHIP_CHANGED_EVENT));
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
